/* unplugin-vue-components disabled */import script from "./HotelStockDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelStockDetails.vue?vue&type=script&setup=true&lang=js"

import "./HotelStockDetails.vue?vue&type=style&index=0&id=159f509f&lang=scss"

const __exports__ = script;

export default __exports__